import jwtDecode from 'jwt-decode';
import http from './httpService';

const apiEndPoint = '/auth/admin';
const tokenKey = 'token';

http.setJwt(getJwt());

export async function login(email, password) {
  const result = await http.post(apiEndPoint, { email, password });
  const { idToken: jwt } = result.data;
  localStorage.setItem(tokenKey, jwt);
}

export function loginWithJwt(jwt) {
  localStorage.setItem(tokenKey, jwt);
}

export function logout() {
  localStorage.removeItem(tokenKey);
}

export function getCurrentUser() {
  try {
    const jwt = localStorage.getItem(tokenKey);
    return jwtDecode(jwt);
  } catch (ex) {
    return null;
  }
}

export function getJwt() {
  return localStorage.getItem(tokenKey);
}

export default {
  login,
  loginWithJwt,
  logout,
  getCurrentUser,
  getJwt
};
